import * as React from "react";
import type { SVGProps } from "react";
const SvgBaseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="base_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M640 170.667A21.333 21.333 0 0 1 618.667 192H405.333a21.333 21.333 0 0 1 0-42.667h213.334A21.333 21.333 0 0 1 640 170.667zM618.667 64H405.333a106.667 106.667 0 0 0-97.792 64h-8.874A170.667 170.667 0 0 0 128 298.667v490.666A170.667 170.667 0 0 0 298.667 960h426.666A170.667 170.667 0 0 0 896 789.333V298.667A170.667 170.667 0 0 0 725.333 128h-8.874a106.667 106.667 0 0 0-97.792-64zm97.792 149.333h8.874a85.333 85.333 0 0 1 85.334 85.334v490.666a85.333 85.333 0 0 1-85.334 85.334H298.667a85.333 85.333 0 0 1-85.334-85.334V298.667a85.333 85.333 0 0 1 85.334-85.334h8.874a106.667 106.667 0 0 0 97.792 64h213.334a106.667 106.667 0 0 0 97.792-64zm-417.792 256c0-23.552 17.365-42.666 38.784-42.666h349.098c21.419 0 38.784 19.114 38.784 42.666S707.968 512 686.55 512H337.493c-21.461 0-38.826-19.115-38.826-42.667zm0 170.667c0-23.552 17.365-42.667 38.784-42.667h349.098c21.419 0 38.784 19.115 38.784 42.667s-17.365 42.667-38.784 42.667H337.493c-21.461 0-38.826-19.115-38.826-42.667z"
    />
  </svg>
);
export default SvgBaseIcon;
